import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/x-circle-outline-gray.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0cc1511e")

_pushScopeId("data-v-0cc1511e")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = {
  tabindex: "-1",
  class: "w-full truncate self-center align-middle focus:outline-none pl-1"
}
const _hoisted_4 = { class: "content-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "w-5",
  alt: "chevron"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "w-5",
  alt: "chevron"
}
const _hoisted_7 = { class: 
            `inline-block relative bottom-0 left-0 text-12px xxl:text-14px w-full`
           }
const _hoisted_8 = { class: "absolute z-30 top-full bg-white w-full pr-4" }
const _hoisted_9 = {
  key: 0,
  class: "w-full top-full z-30 bg-white absolute border border-gray-lp-400 rounded-b-md"
}
const _hoisted_10 = {
  key: 0,
  class: "p-2"
}
const _hoisted_11 = {
  key: 1,
  class: "py-4 px-2 mb-2 text-gray-lp-300 flex justify-center text-center items-center"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_2,
  class: "w-8",
  alt: "x-circle-outline-gray"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (!_ctx.searchCustomerNameMode)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: 
            `inline-block relative bottom-0 left-0 text-12px xxl:text-14px ${_ctx.prefixWidth}`
          
            }, [
              _createVNode("div", {
                tabindex: _ctx.disabled ? '-1' : '0',
                id: _ctx.countryCodeButtonId,
                class: 
              `flex rounded-l border item-center ${
                _ctx.error ? 'border-red-lp-800' : 'border-gray-lp-400'
              } leading-tight px-2 py-2.5 xxl:py-2.5 font-normal ${
                _ctx.disabled
                  ? 'bg-gray-lp-1500 cursor-not-allowed text-gray-lp-600'
                  : 'bg-gray-lp-700 text-black-lp-300'
              }`
            ,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOpenSearch && _ctx.onOpenSearch(...args))),
                onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onKeyDownCountryCode && _ctx.onKeyDownCountryCode(...args)))
              }, [
                _createVNode("button", _hoisted_3, _toDisplayString(_ctx.codeProp), 1),
                _createVNode("div", _hoisted_4, [
                  (_ctx.isOpenSearch)
                    ? (_openBlock(), _createBlock("img", _hoisted_5))
                    : (_openBlock(), _createBlock("img", _hoisted_6))
                ])
              ], 42, ["tabindex", "id"])
            ], 2))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", {
            class: 
              `${
                _ctx.disabled
                  ? 'bg-gray-lp-1500 cursor-not-allowed text-gray-lp-600'
                  : 'bg-white text-black-lp-300'
              } rounded-r border-t border-r border-b ${
                _ctx.searchCustomerNameMode ? 'rounded-l border-l' : ''
              } ${
                _ctx.error ? 'border-red-lp-800' : 'border-gray-lp-400'
              } leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
            
          }, [
            (!_ctx.searchCustomerNameMode)
              ? (_openBlock(), _createBlock("input", {
                  key: 0,
                  ref: "searchCustomer",
                  id: _ctx.phoneNumberFieldId,
                  type: "text",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formatText($event))),
                  maxlength: _ctx.maxLength,
                  placeholder: _ctx.$t(_ctx.placeholder),
                  value: _ctx.phone,
                  onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                  disabled: _ctx.disabled,
                  class: 
                `w-full truncate self-center focus:outline-none`
              ,
                  autocomplete: "off",
                  onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
                }, null, 40, ["id", "maxlength", "placeholder", "value", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.searchCustomerNameMode)
              ? _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  ref: "searchCustomer",
                  id: _ctx.phoneNumberFieldId,
                  type: "text",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formatText($event))),
                  maxlength: _ctx.maxLength,
                  placeholder: _ctx.$t(_ctx.placeholder),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.customerNameModel = $event)),
                  onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
                  disabled: _ctx.disabled,
                  class: 
                `w-full truncate self-center focus:outline-none`
              ,
                  autocomplete: "off",
                  onKeydown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
                }, null, 40, ["id", "maxlength", "placeholder", "disabled"])), [
                  [_vModelText, _ctx.customerNameModel]
                ])
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        (_ctx.isOpenSearch)
          ? (_openBlock(), _createBlock(_component_SelectSearch, {
              key: 0,
              ref: "searchCountryRef",
              placeholder: _ctx.$t('bookingV3.searchCountryPlaceholder'),
              customValueStyle: "text-sm",
              keyValue: "code",
              keyName: "name",
              secondKeyName: "code",
              options: _ctx.dataSearch,
              close: _ctx.onCloseSearch,
              modelValue: _ctx.searchCountryModel,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchCountryModel = $event)),
              onFilter: _ctx.onSearch,
              onBlur: _ctx.onCloseSearch,
              errorMessage: _ctx.$t('bookingV3.errorCountryNotFound'),
              onTab: _ctx.onTabSearchCountry
            }, null, 8, ["placeholder", "options", "close", "modelValue", "onFilter", "onBlur", "errorMessage", "onTab"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.disabledUserDropdown)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.isCustomerMenuOpen)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode(_component_Skeleton, {
                          height: "1.3rem",
                          width: "88%",
                          class: "my-2"
                        }),
                        _createVNode(_component_Skeleton, {
                          height: "1.3rem",
                          width: "94%",
                          class: "my-2"
                        }),
                        _createVNode(_component_Skeleton, {
                          height: "1.3rem",
                          width: "83%",
                          class: "my-2"
                        }),
                        _createVNode(_component_Skeleton, {
                          height: "1.3rem",
                          width: "97%",
                          class: "my-2"
                        })
                      ]))
                    : (_ctx.dataOptions.length === 0 && _ctx.isShowErrorMessage)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          (_ctx.isShowIconEmpty)
                            ? (_openBlock(), _createBlock("img", _hoisted_12))
                            : (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.$t(_ctx.errorMessage)), 1))
                        ]))
                      : (_openBlock(), _createBlock("div", {
                          key: 2,
                          ref: "container",
                          class: "select overflow-auto",
                          style: {"max-height":"200px"},
                          onScrollend: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchNew && _ctx.fetchNew(...args)), ["prevent"]))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataOptions, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              ref: `option${index}`,
                              class: [
                `cursor-pointer flex flex-row items-center justify-between px-4 py-3 hover:bg-gray-lp-700 'text-black-lp-200' ${index ===
                  _ctx.dataOptions.length - 1 && 'pb-2'}`,
                { 'bg-gray-lp-700 text-black-lp-200': _ctx.selectedIndex === index },
              ],
                              onClick: ($event: any) => (_ctx.onChooseSelect(item))
                            }, [
                              _renderSlot(_ctx.$slots, "option", { item: item }, () => [
                                _createVNode("span", {
                                  class: "flex-grow truncate pr-1",
                                  innerHTML: 
                    _ctx.highlightMatch(
                      '+' +
                        item['customerPhoneNumber'] +
                        ' - ' +
                        item['customerName']
                    )
                  
                                }, null, 8, ["innerHTML"])
                              ], true),
                              _withDirectives(_createVNode("button", {
                                ref: `edit-button-${index}`,
                                tabindex: "-1",
                                class: ["flex-grow-0 text-red-lp-300 font-semibold p-1", [
                  {'ring-2 ring-blue': _ctx.selectedEditIndex === index}
                ]],
                                onClick: _withModifiers(($event: any) => (_ctx.editItem(item)), ["stop"])
                              }, _toDisplayString(_ctx.$t("edit")), 11, ["onClick"]), [
                                [_vShow, _ctx.isEditItem]
                              ])
                            ], 10, ["onClick"]))
                          }), 128))
                        ], 544))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: 
        _ctx.error
          ? 'text-red-lp-100 text-12px xxl:text-14px pl-1 pt-2 flex gap-x-2'
          : ''
      
        }, [
          (_ctx.error)
            ? (_openBlock(), _createBlock("img", _hoisted_14))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "error", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.errorCaption)), 1)
          ], {}, true)
        ], 2))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, 
      () => {
        _ctx.onCloseSearch();
      }]
  ])
})